import { useDispatch } from 'react-redux'
import { MapDataSettingsButton as Button } from 'ui-components'
import { openMapDataSettingsDrawer } from '~map-preview/states/ui'
import { owner } from '../render'

const MapDataSettingsButton = owner(() => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(openMapDataSettingsDrawer())
  }

  return <Button onClick={handleClick} />
})

export { MapDataSettingsButton }
